(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/views/moduleview.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/views/moduleview.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.terms_integrity=_svs.terms_integrity||{};
_svs.terms_integrity.templates=_svs.terms_integrity.templates||{};
svs.terms_integrity.templates.moduleview = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n  <div id=\"terms-integrity\"></div>";
},"useData":true});
Handlebars.partials['svs-terms_integrity-moduleview'] = svs.terms_integrity.templates.moduleview;
})(svs, Handlebars);

 })(window);